import { clsx } from 'clsx';

import cls from './ErrorText.module.scss';

type ErrorTextProps = {
  text: string;
  className?: string;
};

export const ErrorText = ({ text, className }: ErrorTextProps) => {
  return <div className={clsx(cls.wrap, className)}>{text}</div>;
};
